import Backbone from 'backbone';

let RouteModel = Backbone.Model.extend({
  /** 
   * @memberOf module:Layers
   * @class RouteModel
   * @extends Backbone.Model
   * @classdesc This model controls the attributes focus and empty for origin and destination autocompletes
   * */
  initialize() {
    this.setVisibility(true);
  },
  /**
   * Change the 'highlighted' state
   * @memberOf module:Layers.RouteModel
   * @function
   */
  toggleHover: function() {
    this.set('highlighted', !this.get('highlighted'));
  },

  /**
   * Set 'highlighted' as true
   * @memberOf module:Layers.RouteModel
   * @function
   */
  onHover: function() {
    this.set('highlighted', true);
  },

  /**
   * Set 'highlighted' as false
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  onLeave: function() {
    this.set('highlighted', false);
  },

  /**
   * Get 'highlighted' state
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  isHovered: function() {
    return this.get('highlighted');
  },
  /**
   * Change the 'selected' state
   * @memberOf module:Layers.RouteModel
   * @function
   */
  toggleSelect: function() {
    this.set('selected', !this.get('selected'));
  },

  /**
   * Set 'selected' as true
   * @memberOf module:Layers.RouteModel
   * @function
   */
  onSelect: function() {
    this.set('selected', true);
  },

  /**
   * Set 'selected' as false
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  onDeselect: function() {
    this.set('selected', false);
  },

  /**
   * Get 'selected' state
   * @memberOf @memberOf module:Layers.RouteModel
   * @function
   */
  isSelected: function() {
    return this.get('selected');
  },
  /** Set 'style' by type (default or basic) 
   *   @memberOf module:Layers.RouteModel
   * @function
   */
  setStyle: function(type) {
    this.set('style', type);
  },
  /** Get 'style' value
   *  @memberOf module:Layers.RouteModel
   * @function
   */
  getStyle: function() {
    return this.get('style');
  },
  /** Set 'agency' 
   *   @memberOf module:Layers.RouteModel
   * @function
   */
  setAgency: function(agency) {
    this.set('agency', agency);
  },
  /** Get 'agency' value
   *  @memberOf module:Layers.RouteModel
   * @function
   */
  getAgency: function() {
    return this.get('agency');
  },
  /** Set 'visibility' 
   *   @memberOf module:Layers.RouteModel
   * @function
   */
  setVisibility: function(isVisible) {
    this.set('visibility', isVisible);
  },

  /** Get 'visibility' value
   *  @memberOf module:Layers.RouteModel
   * @function
   */
  getVisibility: function() {
    return this.get('visibility');
  },

});

export default RouteModel;



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/types/models/RouteModel.js